import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { ICustomerAppsConfig } from '../config/config.module';

@Injectable()
export class ApiVersionInterceptor implements HttpInterceptor {
  constructor(private configService: ConfigService<ICustomerAppsConfig>) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestUrl = request.url;
    const normalizedRequestUrl = requestUrl.replace(/^\/app_dev\.php(.*)/, '$1');
    const isApiUrl =
      requestUrl.startsWith(this.configService.config.apiUrl) ||
      requestUrl.startsWith(this.configService.config.apiPath) ||
      normalizedRequestUrl.startsWith(this.configService.config.apiUrl) ||
      normalizedRequestUrl.startsWith(this.configService.config.apiPath);

    if (isApiUrl) {
      request = request.clone({
        headers: request.headers.set('X-App-Version', this.configService.config.appVersion),
      });
    }

    return next.handle(request);
  }
}
